/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './riderTime.module.scss';
import { useThemeMode } from '../../../states/contexts/theme';  // added by Bearer Web Developer
import { useAppState } from '../../../states/app-state';

interface IShowSteps {

}
const RiderTime: React.FC<IShowSteps> = ({ }) => {

    const appState = useAppState();
    const selectedOrder = appState.selectedOrder;
    const time = selectedOrder?.rider?.path?.time;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.rider_time} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h5>Estimated Arrival Time</h5>
            <p>{time?.split(' ')[0]} <span>{time?.split(' ')[1]}</span></p>
        </div>
    )
}
export default RiderTime;